import { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Button, CircularProgress } from "@mui/material";
import PopAddSpace from "../../components/Space/PopAddSpace";
import Swal from "sweetalert2";


const Spaces = () => {

    const [spaces, setSpaces] = useState([]);
    const [loading, setLoading] = useState(true);
    const [popAddSpace, setPopAddSpace] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSpaces = async () => {
            setLoading(true);
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/space`, { method: 'GET' });
                const json = await res.json();
                setSpaces(json.spaces);
            } catch (error) {
                console.error("Failed to fetch spaces:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchSpaces();
    }, []);


    const onAddSpace = (e, space_id) => {
        setPopAddSpace(false);
        console.log(space_id);
        navigate(`/space/${space_id}`);

    }

    const onDeleteSpace = async (space_id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/space/${space_id}`, {
                    method: 'DELETE'
                });

                if (!response.ok) {
                    throw new Error('Failed to delete space');
                }

                setSpaces(prevSpaces => prevSpaces.filter(space => space.space_id !== space_id));
                Swal.fire('Deleted!', 'The space has been deleted.', 'success');
            } catch (error) {
                console.error("Deletion failed:", error);
                Swal.fire('Error!', 'Could not delete the space.', 'error');
            }
        }
    }


    const onOpenAddSpacePop = (e) => {
        setPopAddSpace(true);
    }

    const onCloseAddSpacePop = (e) => {
        setPopAddSpace(false);
    }

    return (
        <>
            <div className="content-header pb-6 flex justify-between">
                <div className="content-header-label">Spaces</div>
                <div className="content-header-actions">
                    <Button onClick={onOpenAddSpacePop}>Add New Space</Button>
                </div>
            </div>
            <div className="content-body">
                {loading ? (
                    <CircularProgress />
                ) : (
                    <table className="table-auto border w-full">
                        <thead>
                            <tr>
                                <th className="font-bold p-2 border-b text-left w-2">No</th>
                                <th className="font-bold p-2 border-b text-left">Space Name</th>
                                <th className="font-bold p-2 border-b text-left w-[200px]">Beacon ID</th>
                                <th className="font-bold py-2 px-4 border-b text-left w-[200px]">Actions</th>
                            </tr>
                        </thead>
                        <tbody>

                            {spaces.map((space, i) => <tr key={space.space_id}>
                                <td className="p-2 border-b text-left">{i + 1}</td>
                                <td className="p-2 border-b text-left">{space.space_name}</td>
                                <td className="p-2 border-b text-left">{space.space_beacon_id}</td>
                                <td className="py-2 px-4 border-b text-left"> <Link to={`/space/${space.space_id}`}>Edit</Link> / <Button onClick={(e) => onDeleteSpace(space.space_id)}>Delete</Button> </td>
                            </tr>)}

                        </tbody>
                    </table>
                )}
            </div>
            {popAddSpace && <PopAddSpace onAddSpace={onAddSpace} onCloseAddSpacePop={onCloseAddSpacePop} />}

        </>
    )
}

export default Spaces;